
import { Component, OnInit,Inject ,EventEmitter} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService } from '../notification.service';
import { FormBuilder, Validators } from '@angular/forms'
@Component({
  selector: 'app-dltdriverpopup',
  templateUrl: './dltdriverpopup.component.html',
  styleUrls: ['./dltdriverpopup.component.scss']
})
export class DltdriverpopupComponent implements OnInit {
isDeleted4= new EventEmitter
  constructor(@Inject(MAT_DIALOG_DATA) private data:any,private snack:MatSnackBar  ,private notification:NotificationService ,private fb: FormBuilder,public service:CommonService,public dialog: MatDialog,private router: Router,private dialogRef: MatDialogRef<DltdriverpopupComponent>) { }

  ngOnInit(): void {
  }
  driverDelete(){
    this.service.deleteDriver(this.data)
    .subscribe((res:any)=>{
      if(res.message == "Success"){
        // this.snack.open("Delete successfully",'',{
        //   duration:5000,
        //  verticalPosition:'top',
        this.notification.showInfo("Deleted succcessfully",'')
        //  horizontalPosition: 'end',
        // })
        this.isDeleted4.emit(true)
        this.dialogRef.close();
      }else{
        alert("something went wrong");
      }
    })
  }

}
